module.exports = __webpack_public_path__ + "static/img/s208.ba6fd8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s208.png
// module id = 550
// module chunks = 3